import React, { useState } from "react";


import
{
    JWT
}
from "../../../constants/local-storage";

import
{
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import
{
    faWandMagicSparkles,
    faPaperPlane,
    faRotate,
    faLightbulb,
    faScrewdriverWrench,
    faTriangleExclamation
}
from "@fortawesome/free-solid-svg-icons";


export default function AssetAiDrawer(
{
    assetType,
    manufacturer,
    model
})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [summary, setSummary] =
        useState("");

    const [summaryLoading, setSummaryLoading] =
        useState(false);

    const [question, setQuestion] =
        useState("");

    const [answer, setAnswer] =
        useState("");

    const [questionLoading, setQuestionLoading] =
        useState(false);

    const [error, setError] =
        useState("");
		
		
	//--------------------------------------------------------
	// Authentication
	//--------------------------------------------------------

	const token =
	    localStorage.getItem(JWT);


    //--------------------------------------------------------
    // Generate Summary
    //--------------------------------------------------------

    const generateSummary =
        async () =>
        {

            try
            {

                setError("");

                setSummaryLoading(true);


                const response =
                    await fetch(
                        "/resolutionsoftwareplatform/forager/asset-ai",
                        {
                            method:
                                "POST",

								headers:
								{
								    "Content-Type":
								        "application/json",

								    "Authorization":
								        token
								},

                            body:
                                JSON.stringify(
                                {
                                    assetType:
                                        assetType,

                                    manufacturer:
                                        manufacturer,

                                    model:
                                        model
                                })
                        });


                const data =
                    await response.json();


                if (!response.ok)
                {
                    throw new Error(
                        data?.response ||
                        "Unable to generate asset summary."
                    );
                }


                setSummary(
                    data?.response || "");

            }
            catch (exception)
            {

                console.error(
                    "Asset AI summary error",
                    exception);


                setError(
                    exception.message ||
                    "Unable to generate asset summary.");

            }
            finally
            {

                setSummaryLoading(false);

            }

        };


    //--------------------------------------------------------
    // Ask Question
    //--------------------------------------------------------

    const askQuestion =
        async (selectedQuestion) =>
        {

            const questionToAsk =
                selectedQuestion ||
                question;


            if (!questionToAsk ||
                !questionToAsk.trim())
            {
                return;
            }


            try
            {

                setError("");

                setQuestionLoading(true);

                setAnswer("");


                const prompt =
                    "Answer the following question about this asset.\n\n" +

                    "Asset Type: " +
                    assetType +
                    "\n" +

                    "Manufacturer: " +
                    manufacturer +
                    "\n" +

                    "Model: " +
                    model +
                    "\n\n" +

                    "Question:\n" +
                    questionToAsk;


                const response =
                    await fetch(
                        "/resolutionsoftwareplatform/forager/ask-ai",
                        {
                            method:
                                "POST",

								headers:
								{
								    "Content-Type":
								        "application/json",

								    "Authorization":
								        token
								},

                            body:
                                JSON.stringify(
                                {
                                    prompt:
                                        prompt
                                })
                        });


                const data =
                    await response.json();


                if (!response.ok)
                {
                    throw new Error(
                        data?.response ||
                        "Unable to answer question."
                    );
                }


                setQuestion(
                    questionToAsk);


                setAnswer(
                    data?.response || "");

            }
            catch (exception)
            {

                console.error(
                    "Asset AI question error",
                    exception);


                setError(
                    exception.message ||
                    "Unable to answer question.");

            }
            finally
            {

                setQuestionLoading(false);

            }

        };


    //--------------------------------------------------------
    // Suggested Question
    //--------------------------------------------------------

    const suggestedQuestion =
        (text) =>
        {

            setQuestion(
                text);

            askQuestion(
                text);

        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            style={{
                height:
                    "100%",

                overflowY:
                    "auto",

                padding:
                    "24px"
            }}
        >

            {/*========================================================
              Asset Header
            ========================================================*/}

            <div
                style={{
                    paddingBottom:
                        "20px",

                    borderBottom:
                        "1px solid rgba(255,255,255,.08)"
                }}
            >

                <div
                    style={{
                        display:
                            "flex",

                        alignItems:
                            "center",

                        gap:
                            "14px"
                    }}
                >

                    <div
                        style={{
                            width:
                                "48px",

                            height:
                                "48px",

                            borderRadius:
                                "50%",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            background:
                                "rgba(66,191,245,.14)",

                            border:
                                "1px solid rgba(66,191,245,.30)",

                            color:
                                "#42bff5",

                            fontSize:
                                "19px",

                            boxShadow:
                                "0 0 24px rgba(66,191,245,.12)"
                        }}
                    >

                        <FontAwesomeIcon
                            icon={faWandMagicSparkles}
                        />

                    </div>


                    <div>

                        <div
                            style={{
                                color:
                                    "white",

                                fontSize:
                                    "20px",

                                fontWeight:
                                    700
                            }}
                        >

                            {assetType}

                        </div>


                        <div
                            style={{
                                marginTop:
                                    "4px",

                                color:
                                    "rgba(255,255,255,.55)",

                                fontSize:
                                    "13px"
                            }}
                        >

                            {manufacturer}

                            {
                                manufacturer &&
                                model
                                ?
                                " • "
                                :
                                ""
                            }

                            {model}

                        </div>

                    </div>

                </div>

            </div>


            {/*========================================================
              AI Summary
            ========================================================*/}

            <div
                style={{
                    marginTop:
                        "22px"
                }}
            >

                <div
                    style={{
                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "space-between"
                    }}
                >

                    <div>

                        <div
                            style={{
                                color:
                                    "white",

                                fontSize:
                                    "16px",

                                fontWeight:
                                    600
                            }}
                        >

                            AI Asset Summary

                        </div>


                        <div
                            style={{
                                marginTop:
                                    "4px",

                                color:
                                    "rgba(255,255,255,.50)",

                                fontSize:
                                    "12px"
                            }}
                        >

                            Generated using available asset information

                        </div>

                    </div>


                    {
                        summary
                        &&
                        !summaryLoading
                        &&
                        <div
                            onClick={generateSummary}
                            title="Regenerate summary"
                            style={{
                                width:
                                    "34px",

                                height:
                                    "34px",

                                borderRadius:
                                    "50%",

                                display:
                                    "flex",

                                alignItems:
                                    "center",

                                justifyContent:
                                    "center",

                                color:
                                    "#42bff5",

                                background:
                                    "rgba(66,191,245,.10)",

                                border:
                                    "1px solid rgba(66,191,245,.22)",

                                cursor:
                                    "pointer"
                            }}
                        >

                            <FontAwesomeIcon
                                icon={faRotate}
                            />

                        </div>
                    }

                </div>


                {/*====================================================
                  Generate Summary Panel
                ====================================================*/}

                {
                    !summary &&
                    !summaryLoading
                    &&
                    <div
                        style={{
                            marginTop:
                                "14px",

                            padding:
                                "22px",

                            background:
                                "linear-gradient(" +
                                "135deg, " +
                                "rgba(66,191,245,.12) 0%, " +
                                "rgba(66,191,245,.025) 100%" +
                                ")",

                            border:
                                "1px solid rgba(66,191,245,.22)",

                            textAlign:
                                "center"
                        }}
                    >

                        <FontAwesomeIcon
                            icon={faWandMagicSparkles}
                            style={{
                                color:
                                    "#42bff5",

                                fontSize:
                                    "25px"
                            }}
                        />


                        <div
                            style={{
                                marginTop:
                                    "13px",

                                color:
                                    "rgba(255,255,255,.72)",

                                fontSize:
                                    "13px",

                                lineHeight:
                                    "20px"
                            }}
                        >

                            Generate an AI overview including operation,
                            inspection requirements, typical maintenance,
                            common faults and lifecycle considerations.

                        </div>


                        <button
                            onClick={generateSummary}
                            style={{
                                marginTop:
                                    "18px",

                                padding:
                                    "11px 22px",

                                border:
                                    "none",

                                borderRadius:
                                    "0px",

                                background:
                                    "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)",

                                color:
                                    "white",

                                fontWeight:
                                    600,

                                fontSize:
                                    "13px",

                                cursor:
                                    "pointer",

                                boxShadow:
                                    "0 7px 20px rgba(21,155,215,.25)"
                            }}
                        >

                            Generate AI Summary

                        </button>

                    </div>
                }


                {/*====================================================
                  Summary Loading
                ====================================================*/}

                {
                    summaryLoading
                    &&
                    <LoadingPanel
                        text="Analysing asset..."
                    />
                }


                {/*====================================================
                  Summary Result
                ====================================================*/}

                {
                    summary &&
                    !summaryLoading
                    &&
                    <AiResponsePanel
                        text={summary}
                    />
                }

            </div>


            {/*========================================================
              Ask OmniScan
            ========================================================*/}

            <div
                style={{
                    marginTop:
                        "28px",

                    paddingTop:
                        "24px",

                    borderTop:
                        "1px solid rgba(255,255,255,.08)"
                }}
            >

                <div
                    style={{
                        display:
                            "flex",

                        alignItems:
                            "center",

                        gap:
                            "10px"
                    }}
                >

                    <FontAwesomeIcon
                        icon={faLightbulb}
                        style={{
                            color:
                                "#42bff5"
                        }}
                    />


                    <div
                        style={{
                            color:
                                "white",

                            fontSize:
                                "16px",

                            fontWeight:
                                600
                        }}
                    >

                        Ask OmniScan

                    </div>

                </div>


                <div
                    style={{
                        marginTop:
                            "5px",

                        color:
                            "rgba(255,255,255,.50)",

                        fontSize:
                            "12px"
                    }}
                >

                    Ask a question about this asset

                </div>


                {/*====================================================
                  Question Box
                ====================================================*/}

                <div
                    style={{
                        position:
                            "relative",

                        marginTop:
                            "14px"
                    }}
                >

                    <textarea
                        value={question}
                        onChange={(event) =>
                            setQuestion(
                                event.target.value)
                        }
                        placeholder="What would you like to know?"
                        disabled={questionLoading}
                        style={{
                            width:
                                "100%",

                            height:
                                "90px",

                            boxSizing:
                                "border-box",

                            resize:
                                "none",

                            outline:
                                "none",

                            padding:
                                "14px 15px",

                            paddingRight:
                                "52px",

                            background:
                                "rgba(255,255,255,.045)",

                            border:
                                "1px solid rgba(255,255,255,.12)",

                            borderRadius:
                                "0px",

                            color:
                                "white",

                            fontFamily:
                                "inherit",

                            fontSize:
                                "13px",

                            lineHeight:
                                "20px"
                        }}
                    />


                    <div
                        onClick={() =>
                        {
                            if (!questionLoading)
                            {
                                askQuestion();
                            }
                        }}
                        style={{
                            position:
                                "absolute",

                            right:
                                "12px",

                            bottom:
                                "12px",

                            width:
                                "34px",

                            height:
                                "34px",

                            borderRadius:
                                "50%",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            background:
                                questionLoading
                                    ? "rgba(255,255,255,.08)"
                                    : "linear-gradient(180deg, #42bff5 0%, #159bd7 100%)",

                            color:
                                "white",

                            cursor:
                                questionLoading
                                    ? "default"
                                    : "pointer",

                            transition:
                                ".2s"
                        }}
                    >

                        <FontAwesomeIcon
                            icon={faPaperPlane}
                        />

                    </div>

                </div>


                {/*====================================================
                  Suggested Questions
                ====================================================*/}

                <div
                    style={{
                        marginTop:
                            "13px",

                        color:
                            "rgba(255,255,255,.42)",

                        fontSize:
                            "11px",

                        textTransform:
                            "uppercase",

                        letterSpacing:
                            ".6px"
                    }}
                >

                    Suggested questions

                </div>


                <div
                    style={{
                        display:
                            "flex",

                        flexWrap:
                            "wrap",

                        gap:
                            "8px",

                        marginTop:
                            "9px"
                    }}
                >

                    <QuestionChip
                        text="Maintenance requirements"
                        disabled={questionLoading}
                        onClick={() =>
                            suggestedQuestion(
                                "What maintenance should be carried out on this asset and at what typical intervals?"
                            )
                        }
                    />


                    <QuestionChip
                        text="Common faults"
                        disabled={questionLoading}
                        onClick={() =>
                            suggestedQuestion(
                                "What are the most common faults associated with this asset and what symptoms should I look for?"
                            )
                        }
                    />


                    <QuestionChip
                        text="Expected lifecycle"
                        disabled={questionLoading}
                        onClick={() =>
                            suggestedQuestion(
                                "What is the typical expected lifecycle of this asset and what factors affect replacement?"
                            )
                        }
                    />

                </div>


                {/*====================================================
                  Question Loading
                ====================================================*/}

                {
                    questionLoading
                    &&
                    <LoadingPanel
                        text="Considering your question..."
                    />
                }


                {/*====================================================
                  Answer
                ====================================================*/}

                {
                    answer &&
                    !questionLoading
                    &&
                    <div
                        style={{
                            marginTop:
                                "18px"
                        }}
                    >

                        <div
                            style={{
                                color:
                                    "rgba(255,255,255,.45)",

                                fontSize:
                                    "11px",

                                textTransform:
                                    "uppercase",

                                letterSpacing:
                                    ".6px",

                                marginBottom:
                                    "8px"
                            }}
                        >

                            AI Response

                        </div>


                        <AiResponsePanel
                            text={answer}
                        />

                    </div>
                }

            </div>


            {/*========================================================
              Error
            ========================================================*/}

            {
                error
                &&
                <div
                    style={{
                        marginTop:
                            "20px",

                        padding:
                            "14px 16px",

                        display:
                            "flex",

                        alignItems:
                            "flex-start",

                        gap:
                            "10px",

                        background:
                            "rgba(214,40,40,.10)",

                        border:
                            "1px solid rgba(214,40,40,.28)",

                        color:
                            "#ff7a7a",

                        fontSize:
                            "12px",

                        lineHeight:
                            "19px"
                    }}
                >

                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        style={{
                            marginTop:
                                "3px"
                        }}
                    />

                    <div>

                        {error}

                    </div>

                </div>
            }


            {/*========================================================
              AI Disclaimer
            ========================================================*/}

            <div
                style={{
                    marginTop:
                        "24px",

                    paddingTop:
                        "16px",

                    borderTop:
                        "1px solid rgba(255,255,255,.06)",

                    color:
                        "rgba(255,255,255,.30)",

                    fontSize:
                        "10px",

                    lineHeight:
                        "16px"
                }}
            >

                AI-generated information may include general industry
                guidance. Manufacturer documentation and site-specific
                requirements should be verified where applicable.

            </div>

        </div>

    );

}



//=========================================================
// AI RESPONSE PANEL
//=========================================================

function AiResponsePanel(
{
    text
})
{

    return (

        <div
            style={{
                marginTop:
                    "14px",

                padding:
                    "18px",

                background:
                    "linear-gradient(" +
                    "180deg, " +
                    "rgba(255,255,255,.055) 0%, " +
                    "rgba(255,255,255,.025) 100%" +
                    ")",

                border:
                    "1px solid rgba(255,255,255,.09)",

                color:
                    "rgba(255,255,255,.78)",

                fontSize:
                    "13px",

                lineHeight:
                    "21px",

                whiteSpace:
                    "pre-wrap"
            }}
        >

            {text}

        </div>

    );

}



//=========================================================
// LOADING PANEL
//=========================================================

function LoadingPanel(
{
    text
})
{

    return (

        <div
            style={{
                marginTop:
                    "14px",

                height:
                    "110px",

                display:
                    "flex",

                flexDirection:
                    "column",

                alignItems:
                    "center",

                justifyContent:
                    "center",

                background:
                    "rgba(66,191,245,.045)",

                border:
                    "1px solid rgba(66,191,245,.15)"
            }}
        >

            <div
                style={{
                    width:
                        "32px",

                    height:
                        "32px",

                    border:
                        "3px solid rgba(66,191,245,.16)",

                    borderTop:
                        "3px solid #42bff5",

                    borderRadius:
                        "50%",

                    animation:
                        "assetAiSpin .8s linear infinite"
                }}
            />


            <div
                style={{
                    marginTop:
                        "13px",

                    color:
                        "rgba(255,255,255,.60)",

                    fontSize:
                        "12px"
                }}
            >

                {text}

            </div>


            <style>
                {
                    `
                    @keyframes assetAiSpin
                    {
                        from
                        {
                            transform: rotate(0deg);
                        }

                        to
                        {
                            transform: rotate(360deg);
                        }
                    }
                    `
                }
            </style>

        </div>

    );

}



//=========================================================
// QUESTION CHIP
//=========================================================

function QuestionChip(
{
    text,
    onClick,
    disabled
})
{

    return (

        <div
            onClick={() =>
            {
                if (!disabled)
                {
                    onClick();
                }
            }}
            style={{
                padding:
                    "7px 11px",

                background:
                    "rgba(66,191,245,.07)",

                border:
                    "1px solid rgba(66,191,245,.18)",

                color:
                    disabled
                        ? "rgba(255,255,255,.30)"
                        : "#70cef6",

                fontSize:
                    "11px",

                cursor:
                    disabled
                        ? "default"
                        : "pointer",

                transition:
                    ".2s",

                userSelect:
                    "none"
            }}
        >

            {text}

        </div>

    );

}